import { useState } from "react";
import { useToast } from "./useToast";

const useAsyncAction = (actionFn) => {
    const { showError, showSuccess } = useToast();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const execute = async (...args) => {
        setLoading(true);
        setError(null);
        setData(null);

        try {
            const response = await actionFn(...args); // Call API function
            console.log("resresponseponse",response)
            if (response?.success) {
                setData(response);
                showSuccess(response.message || "Action completed successfully!");
            } else {
                throw new Error(response?.message || "Action failed. Please try again.");
            }

            return response;
        } catch (error) {
            setError(error.message);
            showError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return { execute, loading, error, data };
};

export default useAsyncAction;
